import i18n from '@/core/i18n';
import { ChangedFieldsStrategy } from '@/modules/common/components/changed-fields';

import { getLocalizedFieldName } from '../../../utils/time-off-changes/time-off-change-field-name-mapper';
import { formatFieldValue } from '../../../utils/time-off-changes/time-off-change-field-value-formatter';

/**
 * Builds the time-off-domain strategy for the generic ChangedFieldsCell.
 *
 * Time-off changes have no grouping, currency, or synthetic fields; values are
 * day-counts, booleans, and the allocation-format enum. Built lazily (at render)
 * so i18n strings resolve after resources load.
 */
export const createTimeOffChangedFieldsStrategy = (): ChangedFieldsStrategy => {
  const t = i18n.getFixedT(null, 'authenticated.settings');

  return {
    getLocalizedFieldName: field => getLocalizedFieldName(field, t),

    formatFieldValue: (value, field) => formatFieldValue(value, field, t),

    renderValue: formatted => formatted,

    getEmptyStateMessage: () => t('pages.timeOff.details.changesTab.noChanges'),

    strings: {
      arrow: t('pages.timeOff.details.changesTab.valueDisplay.arrow'),
      changesCount: count => t('pages.timeOff.details.changesTab.changesCount', { count }),
    },
  };
};
